<template>
  <el-dialog :visible="visible"
    :append-to-body="true"
    :showClose="true"
    :title="'Comment'"
    @close="close">
    <div class="dialog-input-wrapper">
      <el-input
        type="textarea"
        v-model="localValue"
        :label="'comment'"
      >
      </el-input>
    </div>
    <div class="dialog-footer-wrapper">
      <el-button @click="submit">Submit</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CommentDialog',
  props: {
    value: {
      type: String
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      localValue: this.value || ''
    }
  },
  watch: {
    value(val) {
      this.localValue = val || ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', this.localValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-input-wrapper {
  padding: 16px;
}
.dialog-footer-wrapper {
  padding: 0 16px 16px 16px;
}
</style>
